import { CommonModule } from '@angular/common';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';

import { AlertComponent } from './alert.component';
import { AlertService } from './alert.service';

library.add(far, fas);

@NgModule({
    imports: [
        CommonModule,
        FontAwesomeModule
    ],
    exports: [
        AlertComponent
    ],
    declarations: [
        AlertComponent
    ],
    providers: [
        AlertService
    ]
})
export class AlertModule {
}